export default class FylerWebUtils {

    static queryParam(name) {
        const params = new URLSearchParams(window.location.search);
        return params.get(name);
    };

}
